"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rectangle = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const loader_1 = require("@alfalab/core-components/loader");
const typography_1 = require("@alfalab/core-components/typography");
const index_module_css_1 = __importDefault(require("./index.module.css"));
/**
 * Прямоугольная кнопка с основными действиями.
 *
 * Используется для отображения самых частых действий.
 *
 * [Макет](https://www.figma.com/file/OiFlIdSpmFYZ5zsFGWA3TD/%F0%9F%9B%A0Web-%3A%3A-Click-Components?node-id=90230%3A453178)
 */
exports.Rectangle = (0, react_1.forwardRef)((_a, ref) => {
    var { backgroundColor = 'primary', children, className, dataTestId, disabled, icon, iconWrapperClassName, href, loading, type = 'button' } = _a, rest = __rest(_a, ["backgroundColor", "children", "className", "dataTestId", "disabled", "icon", "iconWrapperClassName", "href", "loading", "type"]);
    const componentProps = {
        className: (0, classnames_1.default)(index_module_css_1.default.component, index_module_css_1.default[backgroundColor], {
            [index_module_css_1.default.disabled]: disabled,
            [index_module_css_1.default.loading]: loading,
        }, className),
        'data-test-id': dataTestId,
    };
    const buttonChildren = ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("span", { role: 'img', className: (0, classnames_1.default)(index_module_css_1.default.iconWrapper, iconWrapperClassName), children: loading ? (0, jsx_runtime_1.jsx)(loader_1.Loader, { dataTestId: 'loader' }) : icon }), (0, jsx_runtime_1.jsx)(typography_1.Typography.Text, { view: 'primary-small', weight: 'medium', className: index_module_css_1.default.label, children: children })] }));
    if (href) {
        return ((0, jsx_runtime_1.jsx)("a", Object.assign({ role: 'button', ref: ref, href: href, "aria-disabled": disabled || loading }, componentProps, rest, { children: buttonChildren })));
    }
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({ ref: ref, 
        // eslint-disable-next-line react/button-has-type
        type: type, disabled: disabled || loading }, componentProps, rest, { children: buttonChildren })));
});
